import { Loader } from '@mantine/core'

import { cn } from 'src/utils'

import VoiceAgentRow from './VoiceAgentRow'

const VoiceAgentsTable = ({ voiceAgents, loading, setSelectedVoiceAgent }) => {
  return (
    <div className="h-full overflow-auto">
      <div
        className={cn(
          'grid grid-cols-7 bg-doubleNickel-gray-50 p-2 text-xs font-semibold text-doubleNickel-gray-700'
        )}
      >
        <div>ID</div>
        <div>Name</div>
        <div>Type</div>
        <div>Voice</div>
        <div>Direction</div>
        <div>Status</div>
        <div>Last Updated</div>
      </div>
      {loading && (
        <div className="flex flex-row items-center justify-center">
          <Loader />
        </div>
      )}
      {!loading && voiceAgents.length === 0 && (
        <div className="flex flex-row items-center justify-center text-xs text-doubleNickel-gray-700">
          No voice agents found
        </div>
      )}
      {!loading && voiceAgents.length > 0 && (
        <div className="flex flex-col">
          {voiceAgents.map((voiceAgent) => (
            <VoiceAgentRow
              key={voiceAgent.voiceAgentId}
              voiceAgent={voiceAgent}
              setSelectedVoiceAgent={setSelectedVoiceAgent}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default VoiceAgentsTable
